import { request } from '../../request';

export async function shareShifts(shiftIds: string[], agenciesUrls: string[], allowMultipleAssignees: boolean) {
  return request.post<void>(`/v2/shifts/share`, {
    shiftIds: shiftIds,
    axTenants: agenciesUrls,
    canHasMultipleAssignee: allowMultipleAssignees,
  });
}
